<template>
  <div class="zhuanxiang">
    <div class="header">
      <div class="title">
        <titleCard title="Special training on dialysis comprehensive management skills"></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft">
          <h4>Capacity Building and Continuing Education Center of the NHC.</h4>
          <h3>Grant designation unit</h3>
          <p>
           In order to establish a standardized and standardized system for the diagnosis and treatment of end-stage renal disease and promote the sharing of high-quality medical resources, and improve the overall level of Nephrology and dialysis industry and the job competence of professionals, the national health and Health Commission capacity building and continuing education center initiated the "" special training on capacity building for comprehensive management of dialysis "" program, through "" online theory + online real operation "" way to train the relevant medical and health technical personnel, Center to award a certificate of qualifications for training.
          </p>
        </div>
        <div class="right animate__animated wow animate__fadeInRight">
          <img
            src="../../assets/image/Science/zhuanxiang/zhuanxiang1.webp"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 专家授课 -->
    <div class="zhuanjia">
      <div class="title animate__animated wow animate__fadeInUp">
        <titleCard title="Leading Experts Teaching Team"></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInUp">
          <img
            src="../../assets/image/Science/zhuanxiang/zhuanxiang2.webp"
            alt=""
          />
        </div>
        <div class="right">
          <div
            class="box box1 animate__animated wow animate__fadeInUp"
            data-wow-duration="1s"
          >
            Team of 50 well-known experts and professors<br />Over 300 theoretical courses in dialysis<br />Live Webcast Classes + Recorded Classes + Online Q&A
          </div>
          <div
            class="box box2 animate__animated wow animate__fadeInUp"
            data-wow-duration="1.4s"
          >
            National Continuing Medical Education & National Health Care Open University integrate high-quality continuing medical education resources to provide professional policy, knowledge and skills training for medical staff nationwide, with a focus on grassroots and urgently-needed disciplines.
          </div>
        </div>
      </div>
      <div class="content-ios">
        <div class="right">
          <div
            class="box box1 animate__animated wow animate__fadeInUp"
            data-wow-duration="1s"
          >
            Team of 50 well-known experts and professors<br />Over 300 theoretical courses in dialysis<br />Live Webcast Classes + Recorded Classes + Online Q&A
          </div>
          <div
            class="box box2 animate__animated wow animate__fadeInUp"
            data-wow-duration="1.4s"
          >
            National Continuing Medical Education & National Health Care Open University integrate high-quality continuing medical education resources to provide professional policy, knowledge and skills training for medical staff nationwide, with a focus on grassroots and urgently-needed disciplines.
          </div>
        </div>
        <div class="left animate__animated wow animate__fadeInUp">
          <img
            src="../../assets/image/Science/zhuanxiang/zhuanxiang2.webp"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 教学模式 -->
    <div class="jiaoxue">
      <div class="title animate__animated wow animate__fadeInUp">
        <titleCard title="Teaching Mode"></titleCard>
      </div>
      <div class="txet animate__animated wow animate__fadeInUp">
        Online Theory Learning + Offline Simulation Training + Clinical Practice
      </div>
      <div class="content">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="titletxt"><span>Online learning</span></div>
          <div class="lunbo">
            <el-carousel
              trigger="click"
              :autoplay="false"
              indicator-position="none"
              arrow="always"
            >
              <el-carousel-item
                v-for="(item, index) in lunboList1"
                :key="index"
              >
                <div class="pic"><img :src="item.pic1" alt="" /></div>
                <div class="pic"><img :src="item.pic2" alt="" /></div>
                <div class="pic"><img :src="item.pic3" alt="" /></div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="lunbo-ios">
            <el-carousel
              arrow="always"
              type="card"
              trigger="click"
              :autoplay="false"
            >
              <el-carousel-item
                v-for="(item, index) in lunboListIos1"
                :key="index"
              >
                <img :src="item" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="titletxt"><span>Simulation training</span></div>
          <div class="lunbo">
            <el-carousel
              trigger="click"
              :autoplay="false"
              indicator-position="none"
              arrow="always"
            >
              <el-carousel-item
                v-for="(item, index) in lunboList2"
                :key="index"
              >
                <div class="pic"><img :src="item.pic1" alt="" /></div>
                <div class="pic"><img :src="item.pic2" alt="" /></div>
                <div class="pic"><img :src="item.pic3" alt="" /></div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="lunbo-ios">
            <el-carousel
              arrow="always"
              type="card"
              trigger="click"
              :autoplay="false"
            >
              <el-carousel-item
                v-for="(item, index) in lunboListIos2"
                :key="index"
              >
                <img :src="item" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="titletxt"><span>Clinical practice</span></div>
          <div class="lunbo">
            <el-carousel
              trigger="click"
              :autoplay="false"
              indicator-position="none"
              arrow="always"
            >
              <el-carousel-item
                v-for="(item, index) in lunboList3"
                :key="index"
              >
                <div class="pic"><img :src="item.pic1" alt="" /></div>
                <div class="pic"><img :src="item.pic2" alt="" /></div>
                <div class="pic"><img :src="item.pic3" alt="" /></div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="lunbo-ios">
            <el-carousel
              arrow="always"
              type="card"
              trigger="click"
              :autoplay="false"
            >
              <el-carousel-item
                v-for="(item, index) in lunboListIos3"
                :key="index"
              >
                <img :src="item" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <!-- 培训基地 -->
    <div class="peixuan animate__animated wow animate__fadeIn">
      <div class="title">
        <titleCard title="Training Base"></titleCard>
      </div>
      <p class="titletxt">Provincial CDC 3A-Garde Hospitals</p>
      <div class="poBox">
        <p><span>21</span>provinces</p>
        <p><span>25</span>training bases</p>
      </div>
    </div>
    <!-- 培训资质 -->
    <div class="zizhi">
      <div class="title">
        <titleCard title="Aptitude"></titleCard>
      </div>
      <div class="boxs">
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1s"
        >
          <div class="box-pic">
            <img
              src="../../assets/image/Science/zhuanxiang/zhengshu1.webp"
              alt=""
            />
          </div>
          <p class="box-txt">Training base certificate</p>
        </div>
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1.3s"
        >
          <div class="box-pic">
            <img
              src="../../assets/image/Science/zhuanxiang/zhengshu2.webp"
              alt=""
            />
          </div>
          <p class="box-txt">Teacher Certificate</p>
        </div>
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1.3s"
        >
          <div class="box-pic">
            <img
              src="../../assets/image/Science/zhuanxiang/zhengshu.png"
              alt=""
            />
          </div>
          <p class="box-txt">Letter of appointment for experts</p>
        </div>
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1.9s"
        >
          <div class="box-pic">
            <img
              src="../../assets/image/Science/zhuanxiang/zhengshu4.webp"
              style="width:60%"
            />
          </div>
          <p class="box-txt">Certificate of competency in training</p>
        </div>
      </div>
    </div>
    <!-- 课程体系 -->
    <div class="kecheng">
      <div class="title">
        <titleCard title="Curriculum system"></titleCard>
      </div>
      <div class="main animate__animated wow animate__fadeInUp"></div>
      <div v-if="false" class="footer animate__animated wow animate__fadeInUp">
        <span @click="openWeapp">透析专项培训报名入口</span>
      </div>
    </div>
    <footerCard name="Mr Ji" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from "../../components/footer-card.vue";
import titleCard from "../../components/title-card.vue";
export default {
  data() {
    return {
      lunboList1: [
        {
          pic1: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/06897BF8435B41FBB0BD752813783160-6-2.png",
          pic2: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/18EA6A9B9ACD4F5CAE4E11B677503943-6-2.png",
          pic3: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/46438BF777C04BF480040BA5C873FA0B-6-2.png",
        },
        {
          pic1: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/3A3925900B56422F85BD92FA38045D7C-6-2.png",
          pic2: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/18776C484FC24FE6AE1D9D9B51286814-6-2.png",
          pic3: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/23F84116D81045C39EC6EA4E607BD84A-6-2.png",
        },
      ],
      lunboList2: [
        {
          pic1: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8E4148CB57544C299EA747DDA094B106-6-2.png",
          pic2: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/54DF80E41174471D89CBE1F9B8352F5D-6-2.png",
          pic3: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/6CFC4AE591E74AAAB37B55C26A503124-6-2.png",
        },
        {
          pic1: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/C6A203D24BB44CF4821B2A174A2BE99A-6-2.png",
          pic2: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/260DC43FAB02460AB1FAFCCCCD7A78FC-6-2.png",
          pic3: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8B450486D23F4A14AAC2BD7ED8F760A0-6-2.png",
        },
      ],
      lunboList3: [
        {
          pic1: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8A56F77727CB43908B5476D0B6BF39FC-6-2.png",
          pic2: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/B5FD9405532A41BC84C01F58B2B69C33-6-2.png",
          pic3: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/B23B4C47EDEC422BAE565854AFE6F5C0-6-2.png",
        },
        {
          pic1: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/35DD80955D3B4C2D8FBCB6621EB25D9E-6-2.png",
          pic2: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/118B8CCA3EF249CFA09CB848F73AA395-6-2.png",
          pic3: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/C5839EF62744434CA761BFC5CB1D21C5-6-2.png",
        },
      ],
      lunboListIos1: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/06897BF8435B41FBB0BD752813783160-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/18EA6A9B9ACD4F5CAE4E11B677503943-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/46438BF777C04BF480040BA5C873FA0B-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/3A3925900B56422F85BD92FA38045D7C-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/18776C484FC24FE6AE1D9D9B51286814-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/23F84116D81045C39EC6EA4E607BD84A-6-2.png",
      ],
      lunboListIos2: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8E4148CB57544C299EA747DDA094B106-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/54DF80E41174471D89CBE1F9B8352F5D-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/6CFC4AE591E74AAAB37B55C26A503124-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/C6A203D24BB44CF4821B2A174A2BE99A-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/260DC43FAB02460AB1FAFCCCCD7A78FC-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8B450486D23F4A14AAC2BD7ED8F760A0-6-2.png",
      ],
      lunboListIos3: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8A56F77727CB43908B5476D0B6BF39FC-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/B5FD9405532A41BC84C01F58B2B69C33-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/B23B4C47EDEC422BAE565854AFE6F5C0-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/35DD80955D3B4C2D8FBCB6621EB25D9E-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/118B8CCA3EF249CFA09CB848F73AA395-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/C5839EF62744434CA761BFC5CB1D21C5-6-2.png",
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    openWeapp() {
      location.href = "weixin://dl/business/?t=xxxxxx";
    },
  },
  components: {
    footerCard,
    titleCard,
  },
};
</script>

<style scoped lang="scss">
.zhuanxiang {
  .jiaoxue {
    .title {
      padding: 0.9263rem 0 0.4rem 0;
    }
    .txet {
      color: #272b2d;
      font-size: 0.2526rem;
      padding-bottom: 0.3789rem;
      text-align: center;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        padding: 15px 0 41px 0;
      }
    }
    .content {
      background-color: #fbfbfb;
      overflow: hidden;
      .box {
        margin-bottom: 1.3053rem;
        overflow: hidden;
        .titletxt {
          width: 80%;
          padding-bottom: 0.1684rem;
          border-bottom: 1px solid #e8e8e8;
          margin: 0.5474rem auto;
          color: #0ca6eb;
          font-size: 0.2526rem;
          span {
            display: block;
            width: 2.579rem;
            text-align: center;
            position: relative;
            @media screen and (max-width: 540px) {
              width: 80px;
              font-size: 15px;
            }
          }
          span::after {
            content: "";
            position: absolute;
            bottom: -0.1895rem;
            left: 0;
            height: 0.0316rem;
            width: 100%;
            background-color: #0ca6eb;
          }
        }
        .lunbo-ios {
          display: none;
          @media screen and (max-width: 540px) {
            display: block;
          }
          height: 160px;
          // padding-bottom: 24px;
          padding-top: 20px;
          .el-carousel__item img {
            height: 100%;
            width: 100%;
          }
          /deep/ .el-carousel__container {
            height: 90%;
          }
          /deep/ .el-carousel__arrow {
            @media screen and (max-width: 540px) {
              display: none;
            }
            height: 0.5263rem;
            background-color: #ffffff8e;
            width: 0.5263rem;
            border: 0.0211rem solid #c6c6c6;
            color: #c6c6c6;
            font-size: 0.2737rem;
          }
          /deep/ .el-carousel__indicators {
            @media screen and (max-width: 540px) {
              display: none;
            }
          }
          /deep/ .el-carousel--horizontal {
            height: 100%;
          }
          // /deep/ .el-carousel__arrow--left {
          //   left: -80px;
          // }
          // /deep/ .el-carousel__arrow--right {
          //   right: -80px;
          // }
          /deep/ .el-carousel__button {
            height: 0.0842rem;
            width: 0.3158rem;
            background-color: #c3c3c3;
          }
          /deep/ .el-carousel__indicator.is-active button {
            background-color: #0ca6eb;
          }
          /deep/ .el-carousel__indicator--horizontal {
            padding: 0 0.0421rem;
            padding-top: 0.3158rem;
          }
          .el-carousel__item:nth-child(2n) {
            background-color: #ffffff;
          }

          .el-carousel__item:nth-child(2n + 1) {
            background-color: #ffffff;
          }
        }
        .lunbo {
          @media screen and (max-width: 540px) {
            display: none;
          }
          height: 2.5263rem;
          width: 80%;
          margin: 0 auto;
          /deep/.el-carousel__container {
            height: 2.5263rem;
          }
          /deep/ .el-carousel__arrow {
            height: 0.5263rem;
            background-color: #ffffff8e;
            width: 0.5263rem;
            border: 0.0211rem solid #c6c6c6;
            color: #c6c6c6;
            font-size: 0.2737rem;
          }
          /deep/ .el-carousel__arrow--left {
            left: 0;
          }
          /deep/ .el-carousel__arrow--right {
            right: 0;
          }
          .el-carousel__item {
            overflow: hidden;
            display: flex;
            justify-content: center;
            .pic {
              width: 4.6842rem;
              height: 100%;
              box-sizing: border-box;
              margin: 0 0.0842rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .pic1 {
              margin-left: -3.1579rem;
            }
            .pic4 {
              margin-right: -3.1579rem;
            }
          }
        }
      }
    }
  }
  .header {
    .title {
      padding: 1rem 0 1.2632rem 0;
      @media screen and (max-width: 540px) {
        padding: 37px 0 51px 0;
      }
    }
    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      @media screen and (max-width: 540px) {
        display: block;
        padding: 0 40px;
        box-sizing: border-box;
        height: 100%;
      }
      margin-bottom: 1.0526rem;
      .left {
        width: 6.9474rem;
        padding-right: 1.2632rem;
        @media screen and (max-width: 540px) {
          width: 100%;
        }
        h4 {
          font-size: 0.2947rem;
          color: #272b2d;
          padding: 0.2105rem 0;
          margin: 0;
          @media screen and (max-width: 540px) {
            font-size: 15px;
          }
        }
        h3 {
          margin: 0;
          font-size: 0.3368rem;
          color: #0ca6eb;
          padding-bottom: 0.9053rem;
          position: relative;
          @media screen and (max-width: 540px) {
            font-size: 16px;
          }
        }
        h3::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0.6316rem;
          height: 0.0632rem;
          width: 0.6737rem;
          background-color: #0ca6eb;
          border-bottom-right-radius: 0.1263rem;
          @media screen and (max-width: 540px) {
            width: 32px;
            height: 3px;
          }
        }
        p {
          color: #272b2d;
          line-height: 0.4211rem;
          font-size: 0.2016rem;
          @media screen and (max-width: 540px) {
            font-size: 14px;
            line-height: 26px;
          }
        }
      }
      .right {
        width: 7rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          height: 280px;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .zhuanjia {
    height: 9.1053rem;
    padding: 0.7895rem 0 1.3684rem 0;
    background-color: #fbfbfb;
    box-sizing: border-box;
    @media screen and (max-width: 540px) {
      height: 100%;
    }
    .title {
      margin-bottom: 1.4737rem;
    }
    .content-ios {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      padding: 0 15px;
      box-sizing: border-box;
      .left {
        width: 100%;
        margin-top: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        .box {
          width: 100%;
          color: #272b2d;
          align-items: center;
          font-size: 0.2105rem;
          padding-left: 0.3789rem;
          border-left: 2px solid #d8d8d8;
          font-size: 15px;
          line-height: 26px;
        }
        .box1 {
          // height: 1.0526rem;
          margin: 0.3158rem 0 0.5263rem 0;
        }
        // .box2 {
        //   height: 1.7368rem;
        // }
      }
    }
    .content {
      padding-left: 2.3158rem;
      display: flex;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .left {
        width: 7.7895rem;
        height: 4.5789rem;
        padding-right: 0.7895rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        .box {
          width: 4.6316rem;
          color: #666666;
          display: flex;
          align-items: center;
          font-size: 0.2105rem;
          padding-left: 0.3789rem;
          border-left: 2px solid #d8d8d8;
        }
        .box1 {
          margin: 0.3158rem 0 0.5263rem 0;
        }
        .box2 {
          height: 1.7368rem;
        }
      }
    }
  }
  .peixuan {
    height: 13.5789rem;
    width: 100%;
    position: relative;
    background: url("../../assets/image/Science/zhuanxiang/map.png") no-repeat;
    background-size: 95% 80%;
    background-position: 50% 85%;
    @media screen and (max-width: 540px) {
      height: 480px;
      background-size: 140% 70%;
      background-position: 50% 55%;
    }
    .title {
      padding: 0.4947rem 0 0.4211rem 0;
    }
    .titletxt {
      color: #272b2d;
      text-align: center;
      font-size: 0.2526rem;
    }
    .poBox {
      position: absolute;
      left: 1.5579rem;
      font-size: 0.3368rem;
      line-height: 0.8421rem;
      @media screen and (max-width: 540px) {
        font-size: 18px;
        line-height: 38px;
      }
      color: #272b2d;
      p {
        display: flex;
        span {
          display: block;
          color: #0ca6eb;
          font-weight: 700;
          padding: 0 0.2842rem;
          font-size: 0.6105rem;
          @media screen and (max-width: 540px) {
            font-size: 33px;
          }
        }
        .span2 {
          padding-left: 0;
        }
      }
      bottom: 3.1579rem;
    }
  }
  .zizhi {
    height: 8.6316rem;
    background-color: #fbfbfb;
    .title {
      padding: 1.1263rem 0 1.2632rem 0;
    }
    @media screen and (max-width: 540px) {
      height: 100%;
    }
    .boxs {
      display: flex;
      justify-content: center;
      @media screen and (max-width: 540px) {
        padding: 0 16px;
        box-sizing: border-box;
        justify-content: left;
        flex-wrap: wrap;
      }
      .box {
        margin: 0 0.1368rem;
        width: 4.2105rem;
        height: 3.8737rem;
        @media screen and (max-width: 540px) {
          flex-basis: 47%;
          flex-shrink: 0;
          height: 174px;
          margin-bottom: 18px;
        }
        border: 1px solid #dbdbdb;
        .box-pic {
          padding: 0.1263rem;
          height: 2.7368rem;
          box-sizing: border-box;
          text-align: center;
          @media screen and (max-width: 540px) {
            height: 75%;
          }
          img {
            height: 100%;
            width: 100%;
          }
        }
        .box-txt {
          @media screen and (max-width: 540px) {
            height: 20%;
            font-size: 13px;
          }
          padding-top: 0.2947rem;
          color: #555555;
          font-size: 0.2526rem;
          text-align: center;
        }
      }
    }
  }
  .kecheng {
    .title {
      padding: 0.7368rem 0 0.5263rem 0;
    }
    .main {
      width: 15.4737rem;
      height: 8.5263rem;
      margin: 0 auto;
      background: url("../../assets/image/Science/zhuanxiang/zhuanxiang3.webp")
        no-repeat;
      background-size: 100% 100%;
      margin-bottom: 0.8316rem;
    }
    .footer {
      height: 0.7895rem;
      width: 16.6316rem;
      line-height: 0.7895rem;
      @media screen and (max-width: 540px) {
        height: 37px;
        line-height: 37px;
        width: 100%;
        background-size: 140% 100%;
        font-size: 12px;
        background-position: 52% 0;
      }
      background: url("../../assets/image/Science/zhuanxiang/zhuanxiang4.webp")
        no-repeat;
      background-size: 100% 100%;
      span {
        cursor: pointer;
      }
      margin: 0 auto;
      margin-bottom: 1.6316rem;
      text-align: center;
      font-size: 0.2947rem;
      color: #ffffff;
    }
  }
}
</style>
